<template>
  <div class="base-dialog">
    <el-dialog
      :title="dialogTitle"
      :visible.sync="baseDialogOpen"
      :close-on-click-modal="true"
    >
      <AddNote v-if="contentDialog.addNote" />
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  // eslint-disable-next-line vue/no-reserved-component-names
  name: "Base",
  components: {
    AddNote: () => import("../dialog/AddNote"),
  },
  computed: {
    ...mapState("Dialog", ["contentDialog", "dialogTitle"]),
    baseDialogOpen: {
      get() {
        return this.$store.state.Dialog.baseDialogOpen;
      },
      set(value) {
        this.$store.commit("Dialog/setData", {
          label: "baseDialogOpen",
          data: value,
        });
      },
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";
.base-dialog {
  .el-dialog {
    width: 45rem;
    max-width: 90%;
    &__header {
      border-bottom: 1px solid $border;
    }
    &__title {
      font-size: 1.8rem;
      line-height: 1.9rem;
      font-weight: 700;
    }
    &__headerbtn {
      display: none;
    }
  }
}
</style>
